import { theme, buttonStyles, cardStyle } from './theme';

// ============================================
// 📦 STYLES PARTAGÉS
// Styles réutilisables dans plusieurs composants
// ============================================

export const commonStyles = {
  // Layout
  page: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '4rem 2rem',
    animation: 'fadeInUp 0.5s ease',
  },
  
  pageMobile: {
    padding: '2rem 1rem',
  },

  // Titres
  pageTitle: {
    fontSize: 'clamp(2rem, 4vw, 3rem)',
    fontWeight: '700',
    marginBottom: '1rem',
    background: `linear-gradient(135deg, ${theme.colors.text} 0%, ${theme.colors.primary} 100%)`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
  
  pageTitleMobile: {
    fontSize: '1.75rem',
  },

  pageSubtitle: {
    fontSize: '1.1rem',
    color: theme.colors.textDark,
    marginBottom: '3rem',
  },
  
  pageSubtitleMobile: {
    fontSize: '0.95rem',
    marginBottom: '2rem',
  },

  sectionTitle: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: theme.colors.text,
    marginTop: '3rem',
    marginBottom: '1.5rem',
    paddingBottom: '0.5rem',
    borderBottom: `2px solid rgba(0, 217, 255, 0.3)`,
  },
  
  sectionTitleMobile: {
    fontSize: '1.25rem',
    marginTop: '2rem',
  },

  // Cards
  card: cardStyle,
  
  cardMobile: {
    padding: '1.25rem',
  },

  cardTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: theme.colors.primary,
    marginBottom: '1rem',
  },

  // Boutons
  primaryButton: buttonStyles.primary,
  secondaryButton: buttonStyles.secondary,
  
  buttonMobile: {
    padding: '0.875rem 1.5rem',
  },

  // Formulaires
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },

  label: {
    color: theme.colors.textMuted,
    fontSize: '0.95rem',
    fontWeight: '500',
  },
  
  labelMobile: {
    fontSize: '0.85rem',
  },

  input: {
    background: theme.colors.backgroundCard,
    border: '2px solid rgba(255, 255, 255, 0.1)',
    borderRadius: theme.borderRadius.md,
    padding: '1rem',
    color: theme.colors.text,
    fontSize: '1rem',
    fontFamily: theme.fonts.main,
    transition: theme.transition.normal,
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  
  inputMobile: {
    padding: '0.875rem',
    fontSize: '0.9rem',
  },

  inputError: {
    borderColor: theme.colors.error,
  },

  textarea: {
    background: theme.colors.backgroundCard,
    border: '2px solid rgba(255, 255, 255, 0.1)',
    borderRadius: theme.borderRadius.md,
    padding: '1rem',
    color: theme.colors.text,
    fontSize: '1rem',
    fontFamily: theme.fonts.main,
    resize: 'vertical',
    minHeight: '120px',
    transition: theme.transition.normal,
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },

  errorText: {
    color: theme.colors.error,
    fontSize: '0.85rem',
  },

  successMessage: {
    background: 'rgba(40, 200, 64, 0.1)',
    border: '1px solid rgba(40, 200, 64, 0.3)',
    color: theme.colors.success,
    padding: '1rem',
    borderRadius: theme.borderRadius.md,
    fontWeight: '500',
  },

  // Tags
  tag: {
    background: 'rgba(0, 217, 255, 0.1)',
    color: theme.colors.primary,
    padding: '0.5rem 1rem',
    borderRadius: theme.borderRadius.full,
    fontSize: '0.9rem',
    fontWeight: '500',
  },
  
  tagMobile: {
    padding: '0.4rem 0.75rem',
    fontSize: '0.8rem',
  },
};
